import { useState, useEffect, useRef } from 'react';
import { Show } from 'react-haiku';

import { DatePicker, Space, Cascader, Divider, Col, Row, Tooltip, Typography, Dropdown, Menu, Steps, Spin, message, Select } from 'antd';
import locale from 'antd/es/date-picker/locale/pt_PT';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import {
  LinkedinLogo,
  FacebookLogo,
  TwitterLogo,
  InstagramLogo
} from "phosphor-react";

import { Button, Form, Input, Radio, Checkbox } from 'antd';

import { PatternFormat } from 'react-number-format';

import { Trans, useTranslation } from 'react-i18next';

const { Text } = Typography;
const appMode = new URLSearchParams(window.location.search).get('mode') || 'intro';
const formLocation = new URLSearchParams(window.location.search).get('panel') || null;
const axios = require('axios').default;

import {
  IconContext,
  HouseLine,
  Calendar,
  Dog,
  UserList,
  Stack,
  UserCircle,
  CurrencyEur,
  CircleWavy,
  ChartLineUp,
  Printer,
  MagnifyingGlass,
  Plus,
  Calculator,
  RocketLaunch,
  Sparkle,
  EnvelopeSimple,
  PhoneCall
} from "phosphor-react";

import "the-new-css-reset/css/reset.css"
import './assets/css/styles.css';
import './assets/css/antd.custom.css';
import Logo from './assets/img/logo.png';
import LogoLetter from './assets/img/logoLetter.png';
import Image from './assets/img/DS5_4763.jpg';

const PageIntro = ({setStep}) => {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('intro.title')}</h1>
      <p><strong>{t('intro.subtitle')}</strong></p>
      <div style={{margin:'4rem -2rem'}}>
        <img src={Image} />
        {/* <Carousel
          slideSize="50%"
          slideGap="md"
          loop
          align="center"
          plugins={[autoplay.current, classnames.current]}
        >
          <Carousel.Slide><img src="https://sensetest.pt/assets/img/fotos/DS5_4763.jpg" /></Carousel.Slide>
          <Carousel.Slide><img src="https://sensetest.pt/assets/img/fotos/DS5_4751.jpg" /></Carousel.Slide>
          <Carousel.Slide><img src="https://sensetest.pt/assets/img/fotos/DS5_5124.jpg" /></Carousel.Slide>
          <Carousel.Slide><img src="https://sensetest.pt/assets/img/img.php?s=600|400&u=/assets/img/fotos/DS5_5018.jpg" /></Carousel.Slide>
        </Carousel>
         */}
      </div>

      <p>
        <Trans
          i18nKey="intro.familyPartnership"
          components={{ strong: <strong /> }}
        />
      </p>

      <p>{t('intro.invitation')}</p>

      <p><strong>{t('intro.opinion')}</strong></p>

      <div style={{marginTop:'5rem'}}>
        <Divider />
        <Button type="primary" onClick={() => setStep('form')}>{t('intro.next')}</Button>
      </div>
    </>
  )
}

const PageForm = ({setStep, submit}) => {
  const { t } = useTranslation();

  const validateMessages = {
    required: t('common.requiredField')
  };

  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (formLocation) {
      form.setFieldsValue({ location: formLocation.toUpperCase() });
    }
  }, [form]);

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  }

  const today = new Date
  const yearList = Array.from({ length: 100 }, (v, i) => ({value:today.getFullYear() - 16 - i}));
  const monthList = [
    {value:1,label:t('form.months.january')},
    {value:2,label:t('form.months.february')},
    {value:3,label:t('form.months.march')},
    {value:4,label:t('form.months.april')},
    {value:5,label:t('form.months.may')},
    {value:6,label:t('form.months.june')},
    {value:7,label:t('form.months.july')},
    {value:8,label:t('form.months.august')},
    {value:9,label:t('form.months.september')},
    {value:10,label:t('form.months.october')},
    {value:11,label:t('form.months.november')},
    {value:12,label:t('form.months.december')},
  ];
  const [dayList,setDayList] = useState([])
  const handleMonthChange = () => {
    let year = form.getFieldValue('year');
    let month = form.getFieldValue('month');

    if (year === undefined || month === undefined) {
      setDayList([])
      return true;
    }

    let lastDayOfMonth = new Date(year, month, 0);
    let list = Array.from({ length: lastDayOfMonth.getDate() }, (v, i) => ({value:i+1}))

    setDayList(list)
  }

  dayjs.extend(customParseFormat);
  const dateFormat = 'YYYY-MM-DD';


  const onFinish = async (values) => {
    setLoading(true);

    const ok = await submit(values);

    if (!ok) {
      setLoading(false);
      messageApi.open({
        type: 'error',
        content: t('form.invalidData'),
      });
      return false
    }

    setStep('message')
  };

  const tosValidator = async (rule,value) => {
    if (value) {
      return Promise.resolve();
    }

    messageApi.open({
      type: 'error',
      content: t('form.consentRequired'),
    });
    return Promise.reject(t('common.requiredField'));
  }

  return (
    <>
      {contextHolder}
      <h1>{t('form.title')}</h1>
      <div style={{marginBottom:'2rem'}}>
        <Divider />
      </div>
      <Spin spinning={loading}>
        <Form layout="horizontal" {...formItemLayout} colon={false} labelAlign="left" form={form} onFinish={onFinish} validateMessages={validateMessages} requiredMark={false}>

          {(appMode=='intro') && (
          <p>
            <Trans
              i18nKey="form.locationIntro"
              components={{
                strong: <strong />,
                porto: <a href="https://goo.gl/maps/DBp3e775mA1WxjEf7" target="_blank" rel="noreferrer" />,
                torresVedras: <a href="https://goo.gl/maps/EUhx4EWzFMG5kccLA" target="_blank" rel="noreferrer" />,
              }}
            />
          </p>
          )}

          <Form.Item name="location" rules={[{ required: true }]} label={t('form.labels.panel')}>
            <Radio.Group required disabled={!!formLocation}>
              <Space direction="vertical">
                <Radio value="PORTO">{t('form.locations.porto')}</Radio>
                <Radio value="TVEDRAS">{t('form.locations.torresVedras')}</Radio>
                <Radio value="EPANEL">{t('form.locations.painelElectronico')}</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          <Form.Item name="name" label={t('form.labels.name')} rules={[{ required: true }]}>
            <Input placeholder={t('form.placeholders.fullName')} />
          </Form.Item>

          <Form.Item name="gender" label={t('form.labels.gender')} rules={[{ required: true }]}>
            <Radio.Group required>
              <Space direction="vertical">
                <Radio value="M">{t('form.gender.male')}</Radio>
                <Radio value="F">{t('form.gender.female')}</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          
          <Form.Item label={t('form.labels.birthDate')}>
            <div style={{display:'flex',gap:'1rem'}}>
              <Form.Item name="year" noStyle><Select style={{width:80}} placeholder={t('form.placeholders.year')} options={yearList} rules={[{ required: true }]} onChange={handleMonthChange} /></Form.Item>
              <Form.Item name="month" noStyle><Select style={{width:120}} placeholder={t('form.placeholders.month')} options={monthList} rules={[{ required: true }]} onChange={handleMonthChange} /></Form.Item>
              <Form.Item name="day" noStyle><Select style={{width:80}} placeholder={t('form.placeholders.day')} options={dayList} rules={[{ required: true }]} /></Form.Item>
            </div>
          </Form.Item>

          <Form.Item name="city" label={t('form.labels.city')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="mobile" label={t('form.labels.mobile')} rules={[{ required: true }]}>
            <PatternFormat format="### ### ###" allowEmptyFormatting customInput={Input} />
        {/* <Input />*/}
          </Form.Item>
          <Form.Item name="email" label={t('form.labels.email')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item name="position" label={t('form.labels.position')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Divider />

          <div style={{margin:'1rem 0'}}>
            <Form.Item name="tos" label={t('form.labels.dataProcessing')} rules={[{ validator : tosValidator }]} noStyle valuePropName="checked">
              <Checkbox>{t('form.consent')}</Checkbox>
            </Form.Item>
          </div>

          <Divider />
          <Form.Item>
            <Button type="primary" htmlType="submit">{t('form.submit')}</Button>
            {(appMode=='intro') && <Button type="secondary" onClick={() => setStep('intro')}>{t('common.back')}</Button>}
          </Form.Item>
        </Form>
      </Spin>
    </>
  )
}

const PageMessage = ({setStep}) => {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t('message.title')}</h1>
      <div style={{marginBottom:'2rem'}}>
        <Divider />
      </div>

      <p style={{textAlign:'center'}}>{t('message.social')}</p>
      <Row justify="center" gutter={[32,32]}>

        <Col style={{textAlign:'center'}}>
          <a href="https://www.linkedin.com/company/sense-test-lda/" target="_blank" rel="noreferrer"><LinkedinLogo size="40" /><br />LinkedIn</a>
        </Col>
        <Col style={{textAlign:'center'}}>
          <a href="https://www.facebook.com/SenseTest/" target="_blank" rel="noreferrer"><FacebookLogo size="40" /><br />Facebook</a>
        </Col>
        <Col style={{textAlign:'center'}}>
          <a href="https://www.instagram.com/sensetest_pt/" target="_blank" rel="noreferrer"><InstagramLogo size="40" /><br />Instagram</a>
        </Col>
        <Col style={{textAlign:'center'}}>
          <a href="https://twitter.com/SenseTest_PT" target="_blank" rel="noreferrer"><TwitterLogo size="40" /><br />Twitter</a>
        </Col>

      </Row>

      &nbsp;
    </>
  )
}

const App = () => {
  const { t } = useTranslation();

  const [step, setStep] = useState(appMode == 'intro' ? 'intro' : 'form');

  const submit = async (values) => {
    try {
      const response = await axios.post('/registo/registo.php',values,{withCredentials: false});
      if (response.data.strStatus!="ok") {
        return false
      }
    } catch (e) {
      console.error(e)
      return false
    }
    return true;
  }

  useEffect(() => {
    window.scrollTo(0,0);
  }, [step]);

  return (
    <IconContext.Provider value={{size: 16,weight: "light"}}>
      <div className="logoHolder">
        <img width={200} src={Logo} className="logo" />
      </div>

      <div className="content">
        <Show>
          <Show.When isTrue={step==='intro'}>
            <PageIntro setStep={setStep} />
          </Show.When>

          <Show.When isTrue={step==='form'}>
            <PageForm setStep={setStep} submit={submit} />
          </Show.When>

          <Show.When isTrue={step==='message'}>
            <PageMessage />
          </Show.When>
         </Show>
      </div>

      <div className="copy">
        <p>&copy; 2023 Sense Test</p><span style={{fontSize:'8px'}}>{t('footer.developedBy')} <a href="https://motivus.pt" target="_blank" rel="noreferrer">motivus.pt</a></span>
      </div>
    </IconContext.Provider>
  )
}

export default App;
